module.exports = __webpack_public_path__ + "img/upload.ce95e9b54d422298fcf403e748d585aa.ce95e9b5.png";